import { AlertTriangle, X } from "lucide-react";

const ConfirmAlert = ({
  open,
  title = "Are you sure?",
  description = "This action cannot be undone.",
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-card rounded-2xl shadow-large max-w-sm w-full">
        {/* Header */}
        <div className="p-4 border-b border-border flex items-center justify-between">
          <div className="flex items-center gap-2">
            <AlertTriangle className="text-destructive" size={20} />
            <h3 className="font-semibold text-foreground">{title}</h3>
          </div>
          <button
            onClick={onCancel}
            className="p-1 rounded-md hover:bg-muted"
          >
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 text-sm text-muted-foreground">
          {description}
        </div>

        {/* Actions */}
        <div className="p-4 flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2 rounded-xl border border-border hover:bg-muted transition"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2 rounded-xl bg-destructive text-white hover:bg-destructive/90 transition"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmAlert;
